var _mask, _g, _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgImgUserApproveCheck = function SvgImgUserApproveCheck(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 356,
    height: 210,
    viewBox: "0 0 356 210",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 69,
    width: 159,
    height: 141
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140.315 186.498L76.9531 208.262C60.9864 213.749 41.597 205.8 33.8724 190.606L3.20459 130.306C-4.52625 115.112 2.21953 98.1914 18.18 92.705L81.5417 70.9402C97.5084 65.4538 116.898 73.4029 124.623 88.5965L155.29 148.897C163.021 164.091 156.282 181.011 140.315 186.498Z",
    fill: "#F1F1F1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140.315 186.498L76.9531 208.262C60.9864 213.749 41.597 205.8 33.8724 190.606L3.20459 130.306C-4.52625 115.112 2.21953 98.1914 18.18 92.705L81.5417 70.9402C97.5084 65.4538 116.898 73.4029 124.623 88.5965L155.29 148.897C163.021 164.091 156.282 181.011 140.315 186.498Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.3569 112.851L48.3678 118.687L43.6919 120.295L48.1807 129.99L47.4513 130.121C42.2517 131.037 39.2965 135.726 40.8551 140.582C42.4138 145.439 47.8939 148.637 53.0998 147.715L56.1423 147.178L73.0005 183.588L97.3277 175.695L90.6193 162.503C101.549 158.045 105.963 146.119 100.445 135.277L85.5195 105.931L65.3569 112.851Z",
    fill: "#CBCBCB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.063 131.737C79.9437 129.763 78.8171 127.341 76.5466 126.328C74.2761 125.316 71.7215 126.096 70.8408 128.071C69.9601 130.046 71.0867 132.467 73.3572 133.48C75.6277 134.492 78.1822 133.712 79.063 131.737Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.7881 127.684C93.6688 125.709 92.5422 123.287 90.2717 122.274C88.0012 121.262 85.4466 122.042 84.5659 124.017C83.6852 125.992 84.8118 128.414 87.0823 129.426C89.3528 130.439 91.9073 129.659 92.7881 127.684Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.7692 138.506L46.865 139.946L46.5283 138.706L57.4326 137.266L57.7692 138.506Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.5232 142.795L85.8125 141.661L88.4746 140.464C90.2141 139.684 90.7752 137.683 89.7278 136.012L84.8149 128.144L85.9933 127.614L90.9061 135.482C92.34 137.783 91.567 140.526 89.1791 141.598L86.5232 142.795Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.0234 146.848C86.1243 147.846 82.4147 148.457 78.4683 147.69L78.6179 146.468C84.042 147.515 89.7715 145.67 92.8015 143.513L93.718 144.529C92.683 145.265 91.0496 146.15 89.0234 146.848Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5286 129.877C53.5923 130.027 55.4689 131.293 56.8405 132.54C57.5387 133.176 58.6423 132.708 58.4677 131.854L56.3604 121.392C56.3604 121.392 80.6876 120.844 89.4659 109.983C98.2441 99.1224 85.189 89.1846 85.189 89.1846C85.189 89.1846 78.8297 93.5113 72.9194 95.0825C67.009 96.6536 22.5442 100.899 34.9447 124.098C38.2428 130.27 42.5571 132.658 42.5571 132.658C42.5571 132.658 45.1756 129.429 51.5286 129.877Z",
    fill: "#989898"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.1529 164.498C85.1765 165.177 82.7076 165.925 80.4694 166.318L80.0767 165.084C84.5468 164.298 90.2078 161.942 90.2639 161.923L90.9435 163.07C90.825 163.126 89.2664 163.775 87.1529 164.498Z",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.783 216.176L53.8791 251.925L48.1869 240.117C35.9984 214.824 47.7131 187.416 74.3658 178.906L89.7714 173.987C116.418 165.477 147.902 179.081 160.097 204.374L165.783 216.176Z",
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.2528 173.825L71.4293 181.643C70.8495 181.818 70.1699 181.519 69.9205 180.964L69.4592 179.972C69.2035 179.424 69.4654 178.838 70.0514 178.657L95.875 170.839C96.4548 170.664 97.1343 170.963 97.3837 171.518L97.8451 172.51C98.1007 173.058 97.8326 173.644 97.2528 173.825Z",
    fill: "#989898"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M301.185 112.179L177.623 154.623L167.691 135.097L291.26 92.6582L301.185 112.179Z",
    fill: "#E5E5E5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M355.388 53.5673L160.309 120.576L150.377 101.056L345.463 34.0469L355.388 53.5673Z",
    fill: "#E5E5E5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M338.075 19.5266L142.996 86.5356L133.064 67.009L328.143 0L338.075 19.5266Z",
    fill: "#E5E5E5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M182.86 144.81C173.763 133.077 156.512 127.834 143.096 135.178C130.171 142.248 124.741 159.274 133.962 171.507C143.145 183.683 161.88 187.916 175.328 180.622C188.502 173.477 192.043 156.656 182.86 144.81Z",
    fill: "#909090"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M184.954 140.989C194.481 152.56 191.432 169.48 178.477 176.999C165.247 184.68 146.394 181.002 136.861 169.1C127.285 157.148 132.21 139.972 144.928 132.522C158.121 124.791 175.521 129.529 184.954 140.989Z",
    fill: "#286DF0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M164.511 139.798C163.339 147.766 162.323 155.758 161.369 163.757C156.232 162.785 153.663 162.305 148.582 161.326C148.302 162.741 148.158 163.452 147.884 164.867C154.723 166.176 158.189 166.812 165.091 168.134C166.182 158.888 167.323 149.648 168.57 140.421C166.943 140.178 166.132 140.053 164.511 139.798Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgImgUserApproveCheck, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "public/media/img_user_approve_check.8aacbcbf.svg";
export { ForwardRef as ReactComponent };